// THE BUILDER'S OWN CHAT as the place a hand-off lands.
//
// The add-app builder (pages/add-app.js) runs its conversation under the
// 'addapp' chat scope: `_ax_*` keys, the app's projectId, and turns the server
// reads as `surface: 'add-app-builder'` — the one surface the free first
// change is waived on. The server marks that surface PER TURN, so a turn on
// the builder's thread sent from the general drawer is an ordinary paid turn.
//
// Persona round 2d (marcus, 390 px, DEV 2026-10-26): scrolled down to the
// preview, he tapped the phone dock's AI "to get my build chat back", got the
// general drawer on a new chat, opened the build thread from its History, and
// his next three changes were quoted 442/389/388 credits.
//
//   addAppBuilderLive        the builder on the page now (the live render
//                            host's builder), or null
//   addAppBuilderThreadOpen  the general drawer holds the open builder's
//                            thread (the same conversation, an app bound)
//   addAppBuilderChatReveal  the builder chat into view, its composer focused
//
// ONE BUILDER AT A TIME (functions/homeBuild.js): the newest render host owns
// the address `__addAppHost` (pages/add-app.js AppRender) and gives it back
// when it leaves. Read here, never written.
//
// FRANK: every export is self-contained; siblings through `this.call`.

export const addAppBuilderLive = function addAppBuilderLive() {
  const win =
    (this && this.context && this.context.window) || (typeof window !== 'undefined' ? window : null)
  const host = win && win.__addAppHost
  const builder = host && host.builder
  const node = builder && builder.node
  return node && node.isConnected ? builder : null
}

// Reads every key up front (reactive callers).
export const addAppBuilderThreadOpen = function addAppBuilderThreadOpen(root) {
  const r = root && typeof root === 'object' ? root : (this && this.state && this.state.root) || {}
  const drawer = r.activeSessionId
  const builder = r._ax_activeSessionId
  const app = r._addAppProjectId
  if (!drawer || drawer !== builder || !app) return false
  return !!this.call('addAppBuilderLive')
}

// Stacked (a phone, a split pane) the builder chat is the column's first
// screen and the preview the next; side by side it is already on screen and
// `nearest` moves nothing. Found through the DOMQL tree, never a selector.
export const addAppBuilderChatReveal = function addAppBuilderChatReveal() {
  const builder = this.call('addAppBuilderLive')
  if (!builder || typeof builder.lookup !== 'function') return false
  const main = builder.lookup('AppMain')
  const chat = main && main.Conversation && main.Conversation.Chat
  const prompt =
    chat && typeof chat.lookdown === 'function' ? chat.lookdown('PromptTextarea') : null
  const node = prompt && prompt.Textarea && prompt.Textarea.node
  if (!node || node.isConnected === false) return false
  if (typeof node.scrollIntoView === 'function') node.scrollIntoView({ block: 'nearest' })
  if (typeof node.focus === 'function') node.focus({ preventScroll: true })
  return true
}
